import leezenApplications from "./leezenApplications";

const leezenApplicationManagementService = [
    {
        matcher: 'leezenApplications',
        reply: config => {
            return [200, leezenApplications];
        }
    },
    {
        matcher: /leezenApplications\/(.*)/,
        reply: config => {
            const id = /leezenApplications\/(.*)/.exec(config.url)[1];
            const data = leezenApplications.find(item => item.uuid === id);
            return [200, data];
        }
    },
]

export default leezenApplicationManagementService;